import * as bi from 'react-bootstrap-icons';
import { IClientTripFullPoint } from '@bustickus/models-client';
import { numberToTwoDigitString, reverseArray, dateFormat } from 'common/helpers';
import { Flex } from 'components';
import { Icon } from 'shared/components';
import './style.scss';

interface IProps {
  points: IClientTripFullPoint[];
  departureCityId: string | undefined | null;
  arrivalCityId: string | undefined | null;
}

function TripPathTime(props: IProps) {
  const departurePoint =
    props.departureCityId != null
      ? props.points.find((x) => x.cityId === props.departureCityId) ?? props.points[0]
      : props.points[0];

  const arrivalPoint =
    props.arrivalCityId != null
      ? reverseArray(props.points).find((x) => x.cityId == props.arrivalCityId) ?? props.points[props.points.length - 1]
      : props.points[props.points.length - 1];

  const departureDateFormat = dateFormat(departurePoint.departureDate, 'DD.MM.YYYY HH:mm');
  const arrivalDateFormat = dateFormat(arrivalPoint.arrivalDate, 'DD.MM.YYYY HH:mm');

  const departureDate = new Date(departurePoint.departureDate ?? '');
  const arrivalDate = new Date(arrivalPoint.arrivalDate ?? '');

  // TODO: Отображать количетсво дней.
  const differenceSeconds = Math.floor((arrivalDate.getTime() - departureDate.getTime()) / 1000);
  const hours = Math.floor(differenceSeconds / 60 / 60);
  const minutes = Math.floor(differenceSeconds / 60) - hours * 60;

  return (
    <Flex direction='column'>
      <div className='tip-time-6qme'>
        Обратите внимание, что в данных о времени отправки и прибытия указывается <b>местное время</b> пунктов маршрута!
      </div>

      <Flex
        direction='row'
        gap={5}
      >
        <Icon color='red'>
          <bi.Clock />
        </Icon>
        <div>Отправление:</div>
        <b>{departureDateFormat.datetime}</b>
        <span>({departureDateFormat.mskTimezone})</span>
      </Flex>
      <Flex
        direction='row'
        gap={5}
      >
        <Icon color='red'>
          <bi.Clock />
        </Icon>
        <div>Прибытие:</div>
        <b>{arrivalDateFormat.datetime}</b>
        <span>({arrivalDateFormat.mskTimezone})</span>
      </Flex>
      <Flex
        direction='row'
        gap={5}
      >
        <Icon color='red'>
          <bi.ClockHistory />
        </Icon>
        <div>Время в пути:</div>
        <b>{numberToTwoDigitString(hours)} ч.</b>
        <b>{numberToTwoDigitString(minutes)} мин.</b>
      </Flex>
    </Flex>
  );
}

export default TripPathTime;
